/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const loaderTokens = {
  CoreBackgroundDefaultColor: '#000000',
  CoreBackgroundDefaultOpacity: '0.6',
  CoreBackgroundComponentColor: '#ffffff',
  CoreBackgroundComponentOpacity: '1',
  CoreStrokeDefaultColor: 'rgba(140, 140, 135, 0.15)',
  CoreStrokeOverlayColor: 'rgba(255, 255, 255, 0.33)',
} as const;
